import { render, staticRenderFns } from "./MediaLibrary.vue?vue&type=template&id=8d1cf732&scoped=true&"
import script from "./MediaLibrary.vue?vue&type=script&lang=js&"
export * from "./MediaLibrary.vue?vue&type=script&lang=js&"
import style0 from "../Style/media-library.scss?vue&type=style&index=0&id=8d1cf732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1cf732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d1cf732')) {
      api.createRecord('8d1cf732', component.options)
    } else {
      api.reload('8d1cf732', component.options)
    }
    module.hot.accept("./MediaLibrary.vue?vue&type=template&id=8d1cf732&scoped=true&", function () {
      api.rerender('8d1cf732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/MediaLibrary/Components/MediaLibrary.vue"
export default component.exports